let routes = [
  {
    path: '/demande-renouvellement-psychologue',
    component: () => import('../views/DemandeRenouvellementPsychologue.vue'),
    props: true
  },
  {
    path: '/demande-renouvellement-psychologue/:step',
    component: () => import('../views/DemandeRenouvellementPsychologue.vue'),
    props: true
  }
]

export default routes;